import React from 'react';

const Hero = ({
  image = '/assets/images/tc-handshake.jpeg',
  // Position for each breakpoint
  position = {
    xs: 'center',      // Mobile (< 640px)
    sm: 'center',      // Small tablets (640px+)
    md: 'center',      // Tablets (768px+)
    lg: 'center',      // Desktop (1024px+)
    xl: 'center',      // Large desktop (1280px+)
    '2xl': 'center'    // Extra large (1536px+)
  },
  heightClass = 'min-h-[50vh] sm:min-h-[60vh] lg:min-h-[75vh]',
  fit = { xs: 'cover', sm: 'cover', md: 'cover', lg: 'cover', xl: 'cover', '2xl': 'cover' },
  backgroundColor = '#ffffff',
  className = '',
  overlay = true,
  contentClassName = 'relative z-10 h-full flex items-center justify-center px-6',
  children
}) => {
  // Handle both string and object position props
  const positions = typeof position === 'string'
    ? { xs: position, sm: position, md: position, lg: position, xl: position, '2xl': position }
    : { xs: 'center', sm: 'center', md: 'center', lg: 'center', xl: 'center', '2xl': 'center', ...position };

  // Handle both string and object fit props
  const fits = typeof fit === 'string'
    ? { xs: fit, sm: fit, md: fit, lg: fit, xl: fit, '2xl': fit }
    : { xs: 'cover', sm: 'cover', md: 'cover', lg: 'cover', xl: 'cover', '2xl': 'cover', ...fit };

  // Generate unique class name to avoid style conflicts between multiple Hero instances
  const heroId = React.useId().replace(/:/g, '');

  return (
    <section
      className={`hero-${heroId} relative ${heightClass} overflow-hidden ${className}`}
      style={{ backgroundColor }}
    >
      <img
        src={image}
        alt="Hero"
        className="absolute inset-0 w-full h-full"
      />

      {/* Responsive styles for all breakpoints */}
      <style>{`
        /* Mobile - xs (default, < 640px) */
        .hero-${heroId} img {
          object-fit: ${fits.xs};
          object-position: ${positions.xs};
        }

        /* Small - sm (640px+) */
        @media (min-width: 640px) {
          .hero-${heroId} img {
            object-fit: ${fits.sm};
            object-position: ${positions.sm};
          }
        }

        /* Medium - md (768px+) */
        @media (min-width: 768px) {
          .hero-${heroId} img {
            object-fit: ${fits.md};
            object-position: ${positions.md};
          }
        }

        /* Large - lg (1024px+) */
        @media (min-width: 1024px) {
          .hero-${heroId} img {
            object-fit: ${fits.lg};
            object-position: ${positions.lg};
          }
        }

        /* Extra Large - xl (1280px+) */
        @media (min-width: 1280px) {
          .hero-${heroId} img {
            object-fit: ${fits.xl};
            object-position: ${positions.xl};
          }
        }

        /* 2XL (1536px+) */
        @media (min-width: 1536px) {
          .hero-${heroId} img {
            object-fit: ${fits['2xl']};
            object-position: ${positions['2xl']};
          }
        }
      `}</style>

      {overlay && (
        <div className="absolute inset-0 bg-black bg-opacity-30" aria-hidden="true"></div>
      )}

      {children && (
        <div className={contentClassName}>
          {children}
        </div>
      )}
    </section>
  );
};

export default Hero;
